/**
 * Auto-hiding sticky header (the "Threads" pattern): the header is already
 * position: sticky (on .shopify-section-group-header-group - see the
 * comment in header.liquid for why it lives there and not on .header
 * itself), so it's already pinned to the top of the viewport for the whole
 * page - this adds the show/hide behavior on top of that pin, since the
 * page is long enough that a header pinned open the whole way down would
 * otherwise just sit there eating vertical space. Scrolling down past the
 * header's own height slides it up out of view; scrolling back up in
 * either direction reveals it again immediately, and it's always visible
 * once the page is scrolled back to the very top.
 *
 * The class is toggled on .header__inner (see .header__inner.header--hidden
 * in header.liquid), not on the sticky element itself - animating a
 * transform directly on a position: sticky element has separate, known
 * cross-browser quirks, so the transform lives one level down instead.
 *
 * Polls scrollY on every animation frame rather than reacting to the
 * 'scroll' event, since real trackpad/wheel input doesn't always deliver
 * 'scroll' events with the granularity a purely event-driven version
 * needs (especially with `scroll-behavior: smooth` set globally - see
 * critical.css). Polling reads window.scrollY directly on a fixed cadence,
 * regardless of how or whether 'scroll' events fire.
 */
(function () {
  var header = document.querySelector('.header');
  if (!header) return;

  var inner = header.querySelector('.header__inner');
  if (!inner) return;

  // The sticky element itself (see header.liquid) - it never moves, so its
  // own backdrop-filter blur has to fade out in step with .inner sliding
  // away (both transition over the same 0.3s ease, from the same class
  // toggle below), or a blurred-but-empty rectangle is left sitting at the
  // top of the viewport once .inner is gone.
  var wrapper = header.closest('.shopify-section-group-header-group');

  // The reference point comparisons are measured against - only moves when
  // a scroll is decisively in one direction (see TOLERANCE below), not on
  // every single frame. This is the same technique Headroom.js and similar
  // hide-on-scroll implementations use, so a brief pause or a few pixels of
  // jitter mid-gesture can't mask a real direction change.
  var referenceY = Math.max(window.scrollY, 0);
  var hidden = false;
  // Ignore net movement smaller than this - filters out jitter without
  // meaningfully delaying an intentional scroll.
  var TOLERANCE = 5;
  // Below 1200px the same element is also the hamburger dropdown's
  // containing block (see header-menu.js) - hiding the header while that
  // dropdown is open would carry the open menu off-screen with it, so
  // scroll-hiding is suspended for as long as it's open.
  var menuToggle = header.querySelector('[data-menu-toggle]');

  function isMenuOpen() {
    return !!menuToggle && menuToggle.getAttribute('aria-expanded') === 'true';
  }

  function setHidden(next) {
    if (next === hidden) return;
    hidden = next;
    inner.classList.toggle('header--hidden', hidden);
    if (wrapper) wrapper.classList.toggle('header-group--hidden', hidden);
  }

  function tick() {
    var currentY = Math.max(window.scrollY, 0);
    var headerHeight = inner.getBoundingClientRect().height;

    if (isMenuOpen() || currentY <= headerHeight) {
      // Always visible near the very top - avoids hiding on the first
      // small downward scroll before the user has gone anywhere - and
      // whenever the mobile dropdown is open.
      setHidden(false);
      referenceY = currentY;
    } else {
      var delta = currentY - referenceY;

      if (delta > TOLERANCE) {
        // Scrolled down decisively since the reference point.
        setHidden(true);
        referenceY = currentY;
      } else if (delta < -TOLERANCE) {
        // Scrolled up decisively since the reference point - reveal.
        setHidden(false);
        referenceY = currentY;
      }
      // Otherwise: movement since the reference point is still within
      // TOLERANCE - hold the current state and reference point rather
      // than resetting them, so small back-and-forth jitter can't mask a
      // real direction change.
    }

    window.requestAnimationFrame(tick);
  }

  window.requestAnimationFrame(tick);
})();
